module.exports = __webpack_public_path__ + "assets/fist-flag.7c6f8458.svg";